@if (component) {
<div [class]="(component.align || '') + ' ' + (component.style || '') + ' ' + (component.color || '')">
    <div *iCms="'text' of component; tag: component.tag; content: component.style !== 'text' ? 'basicHtml' : 'html'">
    </div>
</div>
}